import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Assets from "../../core/assets";
import { useLoginWithTokenMutation } from "../../services/admin/admin.rtk.api";
import { setToken, removeToken } from "../../utils/auth";
import { adminRoutes } from "../../routers/AdminRouters";
import { toast } from "../../core/toast";

const LoginToken: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [loginWithToken, { isLoading }] = useLoginWithTokenMutation();
  const calledRef = useRef(false);
  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    if (!token) {
      toast.error("Invalid or missing login token");

      navigate(adminRoutes.login, { replace: true });
      return;
    }

    const doLogin = async () => {
      try {
        await loginWithToken(token).unwrap();

        // token already set in transformResponse ✅

        navigate(adminRoutes.dashboard, { replace: true });
      } catch (err: any) {
        removeToken(); // ✅ only remove on failure

        toast.error(err?.data?.message || "Token login failed");

        navigate(adminRoutes.login, { replace: true });
      }
    };

    doLogin();
  }, [token]);

  return (
    <div className="h-screen w-full bg-black text-white flex flex-col items-center justify-center">
      {/* Logo */}
      <img
        src={Assets.authDarkLogo}
        alt="Gym Stream"
        className="w-32 h-32 object-contain mb-8"
      />

      {/* Loading Animation */}
      <div className="flex items-center gap-3">
        <svg
          className="animate-spin h-6 w-6 text-[#B6CB24]"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>

        <span className="text-lg text-gray-300">
          {isLoading ? "Signing you in…" : "Please wait…"}
        </span>
      </div>
    </div>
  );
};

export default LoginToken;